import React from 'react';
import './ComingSoon.scss';

export const ComingSoon: React.FC = () => {
  return (
    <div className="coming-soon-container">
      <h1>Coming Soon</h1>
      <p>This page is still in the making. We'll update soon!</p>
    </div>
  );
};